
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"6","width":"20","height":"2","rx":"1","fill":"currentColor"}}),_c('rect',{attrs:{"x":"2","y":"11","width":"20","height":"2","rx":"1","fill":"currentColor"}}),_c('rect',{attrs:{"x":"2","y":"16","width":"20","height":"2","rx":"1","fill":"currentColor"}})])
          )
        }
      }
    